import { cn } from '../../lib/cn';

export function EmptyState({
  className,
  icon: Icon,
  title,
  description,
  action,
  ...props
}) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-4 px-6 py-16 text-center',
        className
      )}
      {...props}
    >
      {Icon && (
        <div
          className="relative flex h-16 w-16 items-center justify-center rounded-2xl"
          style={{
            background: 'var(--dash-primary-soft)',
            border: '1px solid var(--dash-primary-border)',
          }}
        >
          <div
            className="absolute -inset-3 -z-10 rounded-3xl opacity-40 blur-2xl"
            style={{ background: 'var(--dash-primary)' }}
          />
          <Icon
            size={26}
            strokeWidth={1.8}
            style={{ color: 'var(--dash-primary)' }}
          />
        </div>
      )}
      <div className="flex max-w-md flex-col gap-1.5">
        {title && (
          <h3
            className="text-base font-semibold tracking-tight"
            style={{ color: 'var(--dash-text)' }}
          >
            {title}
          </h3>
        )}
        {description && (
          <p
            className="text-xs leading-relaxed"
            style={{ color: 'var(--dash-text-muted)' }}
          >
            {description}
          </p>
        )}
      </div>
      {action && <div className="mt-2 flex items-center gap-2">{action}</div>}
    </div>
  );
}
